const REFERRAL_TYPES = {
    STEEPLE_CHASE: "steeplechase",
    AIME: "aime",
    RAD_CRM: "radcrm",
    MMLA: "mmla",
    EMC: "emc",
    FAMP: "famp",
    IMBA: "imba",
    LO_PORTAL: "theloportal",
    KONNECT: "konnectd",
    MORTGAGE_BROKER_BUILDER: "mortgagebrokerbuilder",
    HOVA_DIGITAL_ENROLL: "hovadigital",
    LODASOFT: "lodasoft"
}

const ENROLL_LINK = {
    SPECIAL_ENROLL_LINK: '/specialenroll/',
    ISA_ENROLL_LINK: '/salesagent/',
    SAME_BILLING: '/samebilling/',
    DIFFERENT_BILLING: 'differentbilling/'
}


const ENROLL_TYPE = {
    DIRECT: 'DIRECT',
    SPECIAL: 'SPECIAL',
    CUSTOMER: 'CUSTOMER',
    PROMO_CODE: 'PROMO_CODE',
    DIFFERENT_BILLING: 'DIFFERENT_BILLING',
    SALES_AGENT: 'SALES_AGENT',
    REFERRAL: 'REFERRAL',
    SAME_BILLING: 'SAME_BILLING',
    ISV: 'ISV'
}

const ENROLL_STEP = {
    STEP1: 1,
    STEP2: 2,
    STEP3: 3,
    ENROLL_SUBMIT: 4
}

const PARTNER_POSTING_URL = {
    [REFERRAL_TYPES.RAD_CRM]: {
        label: 'RAD CRM Posting URL',
        placeHolder: 'Enter RAD CRM Posting URL',
        name: 'radCrmPostingUrl'
    },
    [REFERRAL_TYPES.KONNECT]: {
        label: 'Konnected Posting URL',
        placeHolder: 'Enter Konnected Posting URL',
        name: 'konnectedPostingUrl'
    },
    [REFERRAL_TYPES.MORTGAGE_BROKER_BUILDER]: {
        label: 'Mortgage Broker Builder Posting URL',
        placeHolder: 'Enter Mortgage Broker Builder Posting URL',
        name: 'mortgageBrokerBuilderPostingUrl'
    },
    [REFERRAL_TYPES.HOVA_DIGITAL_ENROLL]: {
        label: 'Hova Digital Posting URL',
        placeHolder: 'Enter Mortgage Broker Builder Posting URL',
        name: 'mortgageBrokerBuilderPostingUrl'
    }
}

const PARTNER_ENROLL_EXTENSION = {
    AIME: "aimeenroll",
    EMC: "emcenroll",
    STEEPLECHASE: "lunnen",
    MMLA: "MMLA", //Michigan Mortgage Lenders Association / MMLA
    FAMP: "FAMP", //Florida Association Of Mortgage Professionals
    RAD_CRM: 'radcrmenroll',
    IMBA: "imbaenroll",
    THELOPORTAL: "theloportalenroll",
    KONNECTD_ENROLL: "konnectdenroll",
    LODASOFT_ENROLL: "lodasoftenroll",
    MORTGAGE_BROKER_BUILDER_ENROLL: "mortgagebrokerbuilderenroll",
    HOVA_DIGITAL_ENROLL: 'hovadigitalenroll'
};

const PARTNER_CONFIG = {
    [REFERRAL_TYPES.STEEPLE_CHASE]: {
        extn: PARTNER_ENROLL_EXTENSION.STEEPLECHASE
    },
    [REFERRAL_TYPES.AIME]: {
        extn: PARTNER_ENROLL_EXTENSION.AIME
    },
    [REFERRAL_TYPES.MMLA]: {
        extn: PARTNER_ENROLL_EXTENSION.MMLA,
        discountText: 'MMLA'
    },
    [REFERRAL_TYPES.EMC]: {
        extn: PARTNER_ENROLL_EXTENSION.EMC,
        discountText: 'EMC'
    },
    [REFERRAL_TYPES.FAMP]: {
        extn: PARTNER_ENROLL_EXTENSION.FAMP,
        discountText: "FAMP"
    },
    [REFERRAL_TYPES.RAD_CRM]: {
        extn: PARTNER_ENROLL_EXTENSION.RAD_CRM,
        discountText: 'RadCRM',
        integrationKey : 'isRadCRM'
    },
    [REFERRAL_TYPES.IMBA]: {
        extn: PARTNER_ENROLL_EXTENSION.IMBA,
        discountText: 'IMBA'
    },
    [REFERRAL_TYPES.LO_PORTAL]: {
        extn: PARTNER_ENROLL_EXTENSION.THELOPORTAL,
        discountText: 'The LO Portal'
    },
    [REFERRAL_TYPES.KONNECT]: {
        extn: PARTNER_ENROLL_EXTENSION.KONNECTD_ENROLL,
        discountText: 'Konnectd',
        integrationKey : 'isKonnected'
    },
    [REFERRAL_TYPES.LODASOFT]: {
        extn: PARTNER_ENROLL_EXTENSION.LODASOFT_ENROLL,
        discountText: 'Lodasoft',
        integrationKey : 'isLodasoft'
    },
    [REFERRAL_TYPES.MORTGAGE_BROKER_BUILDER]: {
        extn: PARTNER_ENROLL_EXTENSION.MORTGAGE_BROKER_BUILDER_ENROLL,
        discountText: 'Mortgage Broker Builder',
        integrationKey : 'isMortgageBrokerBuilder'
    },
    [REFERRAL_TYPES.HOVA_DIGITAL_ENROLL]: {
        extn: PARTNER_ENROLL_EXTENSION.HOVA_DIGITAL_ENROLL,
        integrationKey : 'isHovaDigital'
    }
};



export {
    REFERRAL_TYPES,
    ENROLL_LINK,
    ENROLL_TYPE,
    ENROLL_STEP,
    PARTNER_POSTING_URL,
    PARTNER_ENROLL_EXTENSION,
    PARTNER_CONFIG
}
